import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-14 text-center px-4 text-gray-500 text-lg space-y-4"
}

import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import MainViewCard from '@/components/common/MainViewCard.vue';
import RecordsTable from '@/components/records/RecordsTable.vue';
import { Button } from '@/components/ui/button';
import { ColumnVisibilityMenu } from '@/components/ui/data-table';
import { useStatusPage } from './useStatusPage';

/*
 * Table-only, unlike every other records page under Pigs - a status registration has no dedicated
 * chart to draw, so this page holds no bins and renders no chart card, just the table on the shared
 * `RecordsTable`. The column-visibility control rides in `RecordsTable`'s own `#actions` slot, beside
 * its heading, the same way Slaughters' does.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { columnFilters, columns, columnToggleOptions, facetOptions, isError, isFetching, refetch, refreshAfterFormActivity, setAllColumns, sorting, subtitle, toggleColumn, totals, visibleRows } =
    useStatusPage();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardContentLayout, {
    class: "space-y-8",
    heading: _ctx.$t('views.pigs.statusRecords.header.heading'),
    "has-period-picker": true,
    "has-pig-type-picker": true
  }, {
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.pigs.records.errors.couldNotLoadData')), 1),
            _createVNode(_unref(Button), {
              variant: "outline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(refetch)()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('views.pigs.records.errors.retry')), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createBlock(MainViewCard, {
            key: 1,
            class: "overflow-hidden"
          }, {
            default: _withCtx(() => [
              _createVNode(RecordsTable, {
                sorting: _unref(sorting),
                "onUpdate:sorting": _cache[3] || (_cache[3] = ($event: any) => (_isRef(sorting) ? (sorting).value = $event : null)),
                "column-filters": _unref(columnFilters),
                "onUpdate:columnFilters": _cache[4] || (_cache[4] = ($event: any) => (_isRef(columnFilters) ? (columnFilters).value = $event : null)),
                columns: _unref(columns),
                rows: _unref(visibleRows),
                totals: _unref(totals),
                "facet-options": _unref(facetOptions),
                loading: _unref(isFetching),
                heading: _ctx.$t('views.pigs.statusRecords.table.heading'),
                subtitle: _unref(subtitle),
                onFormActivity: _unref(refreshAfterFormActivity)
              }, {
                actions: _withCtx(() => [
                  _createVNode(_unref(ColumnVisibilityMenu), {
                    options: _unref(columnToggleOptions),
                    label: _ctx.$t('views.pigs.statusRecords.table.columnsButton'),
                    onToggle: _unref(toggleColumn),
                    onSelectAll: _cache[1] || (_cache[1] = ($event: any) => (_unref(setAllColumns)(true))),
                    onDeselectAll: _cache[2] || (_cache[2] = ($event: any) => (_unref(setAllColumns)(false)))
                  }, null, 8, ["options", "label", "onToggle"])
                ]),
                _: 1
              }, 8, ["sorting", "column-filters", "columns", "rows", "totals", "facet-options", "loading", "heading", "subtitle", "onFormActivity"])
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["heading"]))
}
}

})